// src/ai/HostAgent.js
import HostSpeechQueue from "./HostSpeechQueue.js";
import { introLine, timesUp, scoreBump } from "./HostTemplates.js";

export default class HostAgent {
  constructor({ persona = {}, duck = null } = {}) {
    this.voice = new HostSpeechQueue({ duck });
    this.persona = {
      warmth: 0.7, cheeky: 0.2, brevity: 0.8, ...persona
    };
    this.lastSaid = new Set();
    this.teamSeen = new Set();
  }

  onQuestionStart({ q, displayNumber }) {
    this.voice.cancelAll(); // clear stale lines
    const line = introLine({ q, displayNumber });
    this.say(line, { priority: 9, expiresMs: 6000 });
  }

  onTimerTick({ remaining }) {
    if (remaining === 10) this.say("Ten seconds remaining.", { priority: 10, expiresMs: 2000 });
    if (remaining <= 5 && remaining > 0) this.say(String(remaining), { priority: 11, expiresMs: 1300 });
  }

  onTimesUp({ q, sampleTeams = [], answersIn = 0 }) {
    const line = timesUp({ q, answersIn, examples: sampleTeams.slice(0,3) });
    this.say(line, { priority: 12, expiresMs: 4000 });
  }

  onScoresUpdate({ leaderboard = [], movers = [] }) {
    const line = scoreBump({ top: leaderboard, movers });
    if (line) this.say(line, { priority: 6, expiresMs: 8000 });
  }

  onRoundStart({ name }) { this.say(`Round ${name} begins. Good luck!`, { priority: 8, expiresMs: 5000 }); }
  onRoundEnd({ name })   { this.say(`That wraps ${name}. Scores incoming.`, { priority: 8, expiresMs: 5000 }); }

  say(text, opts) {
    if (!text) return;
    // De-dupe immediate repeats
    const key = text.toLowerCase();
    if (this.lastSaid.has(key)) return;
    this.lastSaid.add(key);
    setTimeout(() => this.lastSaid.delete(key), 15000);
    this.voice.enqueue(text, opts);
  }
}
